import restClient from "../restClient";

export const createHelp = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await restClient.post(`helps`, { data: data }, config);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};
